export default __webpack_public_path__ + "images/0xbe9f8c0d6f0fd7e46cdacca340747ea2f247991d.png";